import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { AuthServiceProvider } from '@/providers/auth-service-provider';
import { ApiConfigurationProvider } from '@/providers/api-configuration-provider';
import { router } from '@/routes/router';
import { OrganizationServiceProvider } from '@/providers/organization-service-provider';

const queryClient = new QueryClient();

export function App() {
  return (
    <AuthServiceProvider>
      <OrganizationServiceProvider>
        <QueryClientProvider client={queryClient}>
          <ApiConfigurationProvider>
            <RouterProvider router={router} />
          </ApiConfigurationProvider>
        </QueryClientProvider>
      </OrganizationServiceProvider>
    </AuthServiceProvider>
  );
}
